import MarkdownIt from 'markdown-it';

export type User = {
    avatar?: string;
    username: string;
    name?: string;


    // Available from MSAL AccountInfo type
    // homeAccountId: string;
    // environment: string;
    // tenantId: string;
    // username: string;
    // name?: string;
    // localAccountId: string;
    // idToken?: string;
    // idTokenClaims?: TokenClaims & {
    //     [key: string]: string | number | string[] | object | undefined | unknown;
    // };
    // nativeAccountId?: string;
};

export type Languages = string[];

export type PromptPayload = {
    message: string;
    prompt_template_id?: string;
};

export type ValidatedResponse<T = undefined> = {
    success: boolean;
    message: string;
} & (T extends undefined ? {} : { data: T; });

export type UpdateChatMetadataResponse = ValidatedResponse;

export type ChatMessageFeedbackResponse = {
    feedback: ChatMessageFeedback[];
};

export type ChatMessageFeedback = {
    message_id: string;
    vote: Vote;
    comment: string | null;
};

export type Vote = 1 | 0 | -1;

export type ProductivityGainResponse = ValidatedResponse;

export enum DocumentProcessingMode {
    process = "process",
    none = "none",
    processNonTabular = "process-non-tabular"
}
export type DocumentInfoType = {
    enabled?: boolean;
    formats: string[];
    limitations: string;
    instructions: string;
    /** Maximum document upload size in bytes */
    length: number;
    /** Maximum file upload limit */
    max?: number;

    processing_mode?: DocumentProcessingMode;
};

export type UserPreferences = {
    personas_pinned: string[];
    personas_disable_auto_pin: string[];
    prompts_pinned: string[];
};

export type InfoResponse = {
    user_id: string;
    is_guest?: boolean;
    llm: LlmRawOption[];
    personas?: PersonaOption[];
    access?: AccessInfo;
    documents?: DocumentInfoType;
    preferences: UserPreferences;
};

export type AccessInfo = {
    personas?: Record<string, boolean>;
};

export type TermsResponse = {
    version: string;
    title_text: string;
    text: string;
    culture: string;
};

export type Starter = (string | { prompt: string, autoSubmit?: boolean; });

export type PersonaRevision = {
    build: number;
    label: string;
    version: string;

    llm?: string;

    alpha: boolean;
    beta: boolean;

    characterLimit?: number;
    temperature?: number;

    documents?: Partial<DocumentInfoType>;
};
export type PersonaVersion = {
    version: string;
    date: string;
    highlights: string[];
    revisions: PersonaRevision[];
};

export type LegacyPersonaProperties = {
    beta?: boolean;
    version?: string;
    characterLimit?: number;
    versionHighlights?: string;

    versionsHistory?: {
        version: string;
        releaseDate: string;
    }[];

    documents?: Partial<DocumentInfoType>;
};
export type PersonaOption = {
    key: string;
    type: 'chat' | 'workflow';
    route: string;
    title: string;
    newChatText?: string;
    welcomeTitle?: string;
    description?: string;
    sort?: number;
    starters?: Starter[];

    /**
     * The icon to display in the new chat window. Fallback to persona icon
     * Might return a name to an __Icon__ or return a link to an image __https://...__
     * */
    icon?: string;
    /**
     * The icon to display in the chat history, the chat conversation and in the catalogue. Fallback to `bot` if not provided
     * */
    avatar?: string;

    versions: PersonaVersion[];

};// & LegacyPersonaProperties;
export type LlmRawOption = {
    key: string;
    title: string;
    description: string;
    sort: number;
    provider: string;
    characterLimit: number;
};

export type LlmUIOption = {
    description: string;
    sort: number;
    label: string;
    value: string;
    characterLimit: number;
};

export type WorkflowOptions = {
    form?: {
        form_schema: Record<string, any>;
        form_ui: Record<string, any>;
    };
    values?: {
        [key: string]: any;
    };
};

export type ErrorLabels<T extends string> = Record<T, { h?: string, d?: string; }>;

export interface MarkdownItWithIncrementalDOM extends MarkdownIt {
    renderToIncrementalDOM: (markdown: string) => void;
}


// CookieInformation.declineAllCategories()
// CookieInformation.submitConsent()

// CookieInformation.submitAllCategories()

// CookieConsent.renew()

// CookieInformation.changeCategoryConsentDecision(


declare global {
    interface Window {
        CookieConsent?: {
            renew?: () => void;
        };
        CookieInformation: {
            getConsentGivenFor?: (cookieCategory: 'cookie_cat_statistic' | 'cookie_cat_functional' | 'cookie_cat_marketing') => boolean;
            declineAllCategories?: () => void;
            submitConsent?: () => void;
            submitAllCategories?: () => void;
            changeCategoryConsentDecision?: (cookieCategory: 'cookie_cat_statistic' | 'cookie_cat_functional' | 'cookie_cat_marketing', consent: boolean) => void; // I dont know if this is the correct type
        };

        toggleDetails?: (id: string) => void;
        TogglePage?: (el: HTMLAnchorElement | HTMLButtonElement, pageId: string) => void;
        toggleCookieDetails: (el: HTMLAnchorElement | HTMLButtonElement, descriptionContainerId: string) => void;


        markdownit: MarkdownItWithIncrementalDOM;

        markdownitIncrementalDOM: any;
        IncrementalDOM: any;

        hljs: any;
    }
}
